import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

function About() {
    useEffect(() => {
        document.title = "About — Deepali Agrawal";
    }, []);

    return (
        <div className="section-padding">
            <div className="max-w-3xl">
                {/* Page Title */}
                <h1 className="text-3xl md:text-headline font-fraunces mb-12">
                    About
                </h1>

                {/* Story */}
                <div className="space-y-8 text-body-lg text-warm-gray-600 mb-16">
                    <p>
                        I didn't arrive at design with a single, dramatic moment.
                        It grew slowly — through observation, curiosity, and a habit of paying attention to how things are put together.
                    </p>

                    <p>
                        Over time, design became the way I make sense of information, emotions, and stories — visually.
                    </p>

                    <p className="text-warm-gray-700">
                        What excites me most is work that sits at the intersection of structure and sensitivity. Brand systems that leave room for warmth. Communication that feels considered, not loud.
                    </p>
                </div>

                {/* Values Section */}
                <section className="py-12 border-t border-warm-gray-200 mb-16">
                    <h2 className="text-xl md:text-title font-fraunces mb-8">
                        How I Work
                    </h2>

                    <div className="space-y-6 text-body-lg text-warm-gray-600">
                        <p>
                            In collaborations, I value honesty, clarity, and respect for craft.
                        </p>
                        <p>
                            I enjoy asking questions, refining ideas, and working closely through iterations rather than jumping to quick conclusions.
                        </p>
                        <p>
                            Over the years, I've grown more confident in my instincts — learning when to push, when to pause, and when less truly is more.
                        </p>
                    </div>
                </section>

                {/* Closing */}
                <section className="py-12 border-t border-warm-gray-200">
                    <p className="text-xl font-fraunces text-warm-gray-700 mb-8 italic">
                        I'm still learning. That's part of why I enjoy this work.
                    </p>

                    <Link
                        to="/contact"
                        className="link-arrow text-lg font-medium group"
                    >
                        Get in touch
                        <ArrowRight
                            size={20}
                            className="group-hover:translate-x-2 transition-transform duration-300"
                        />
                    </Link>
                </section>
            </div>
        </div>
    );
}

export default About;
